<template>
  <el-select v-model="selectValue" filterable placeholder="请选择" @change="change">
    <el-option label="请选择" value=""></el-option>
    <el-option v-for="item in options" :key="item.RoleID" :label="item.RoleName" :value="item.RoleID">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'FormRoleSelect',
  data () {
    return {
      options: [],
      selectValue: this.value
    }
  },
  props: {
    value: {
      
    }
  },
  methods: {
    change: function (selVal) {
      this.$emit('input', selVal)
    }
  },
  watch: {
    value (newVal) {
      this.selectValue = newVal
    }
  },
  mounted: function () {
    var that = this
    var args = {
      token: sessionStorage.getItem('token'),
      currentPage: 1,
      pageSize: 99999
    }
    this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/role/list', args, function (data) {
      that.options = data.Data
      console.log('RoleSelect Mounted')
    }, null, null, null)
  }
}
</script>

<style scoped="scoped">
  .el-select {
    width: 100%;
  }
</style>
